export class OrderSave {
    id: number;
    code: string;
    name: string;
    companyId: number;
    offerId: number;
    budgetId: number;
    projectId: number;
    administrationId: number;
    masterTypeId: number;
    typeId: number;
    subTypeId: number;
    employeeId: number;
    accMonthId: number;
    interCompanyId: number;
    partnerId: number;
    uomId: number;
    accountId: number;
    costCenterId: number;
    valueIni: number;
    valueFin: number;
    quantity: number;
    price: number;
    info: string;
    validated: boolean;
}
